import React, { Fragment, Component } from "react";

export class ContactForm extends Component {
    constructor() {
        super()
        this.state = {
            'name': '',
            'email': '',
            'message': '',
            'btn' : 'Send',
            'alert' : false,
            'alertMessage' : null,
            'alertColor' : null
        }

        this.getData = this.getData.bind(this)
        this.submitData = this.submitData.bind(this)
    }

    getData(event) {
        this.setState({
            'alert' : false,
        })

        const { name, value } = event.target
        this.setState({
            [name]: value
        })
    }

    submitData(data) {
        this.setState({
            'btn' : 'Sending...'
        })

        data.preventDefault()
        var email = this.state.email
        var message = this.state.message;
        var name = this.state.name + ' -- from (promise.shedrach.netlify.app)';

        var templateParams = {message: message, from_name: name, reply_to: email, to_name : 'Promise Shedrach | Software Developer', from_email : email};
        const serviceId = 'service_djgaojv';
        const templateId = 'template_359jdek';
        const userId = 'user_l4xrfZPC6R4IJlMVJpmtU';

        this.sendFeedback(serviceId, templateId, templateParams, userId)
     
    }

    sendFeedback (serviceId, templateId, variables, userId) {
        window.emailjs.send(serviceId, templateId, variables, userId
          ).then(res => {
            this.setState({
                'alert' : true,
                'alertMessage' : 'Message successfully sent!',
                'alertColor' : 'green',
                'btn' : 'Send',
                'name': '',
                'email': '',
                'message': '',
            })
          })
          // Handle errors here however you like, or use a React error boundary
          .catch(err => 
            this.setState({
                'alert' : true,
                'alertMessage' : 'Ooohs! An error occured while sending your message',
                'alertColor' : 'red',
                'btn' : 'Send',
            })
        )
      }

   

    render() {
        return (
            <Fragment>
                <section>
                    <h2 id="hook">You have a project for me, Hook me up.</h2>
                   { this.state.alert && <h2 id="alert" style={{ color: this.state.alertColor }}>
                            {this.state.alertMessage}
                        </h2> }
                  
                    <form >
                        <div className="fields">
                            <div className="field half">
                                <input
                                    type="text"
                                    name="name"
                                    id="name"
                                    placeholder="Your Full Name"
                                    value={this.state.name}
                                    required
                                    onChange={this.getData}
                                />
                            </div>
                            <div className="field half">
                                <input
                                    type="email"
                                    name="email"
                                    id="email"
                                    placeholder="Your Email"
                                    value={this.state.email}
                                    required
                                    onChange={this.getData}
                                />
                            </div>
                            
                            <div className="field">
                                <textarea
                                    name="message"
                                    id="message"
                                    placeholder="Enter Message"
                                    required
                                    value={this.state.message}
                                    onChange={this.getData}
                                    cols="12"
                                />
                            </div>
                        </div>
                        <ul className="actions">
                            <li>
                                <button  className="submit-btn"  onClick={this.submitData}>
                                    {this.state.btn}
                    </button>
                            </li>
                        </ul>
                    </form>
                </section>
            </Fragment>
        )
    }
}